import * as THREE from 'three';
import EventDispatcher from './EventDispatcher';
import Global from './Global';
import { FontLoader } from 'three/addons/loaders/FontLoader.js';
import { TextGeometry } from 'three/addons/geometries/TextGeometry.js';
import gsap from 'gsap';
const plutocondregular = '/assets/Fonts/plutocondregulartypeface.json';
const PlutoCondBlack = '/assets/Fonts/Pluto_Cond_Black_Regulartypeface.json';

export default class LeaderBoard {
  constructor(scene, camera, renderer) {
    this.scene = scene;
    this.camera = camera;
    this.renderer = renderer;

    document
      .querySelector('#relocate')
      .addEventListener('click', this.relocateLeaderboard.bind(this));
    document
      .querySelector('#voteNow')
      .addEventListener('click', this.enableVoting.bind(this));
  }

  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    this.alreadyVoted = false;
    this.canDoVoting = false;
    this.platformItems = [];
  }

  onEvents(data) {
    switch (data.message.event_type) {
      case 'show_screen':
        this.showLeader(data.message.data);
        break;
      case 'load_complete':
        this.onReady();
        break;
      // case 'enable_voting':
      //   this.enableVoting();
      //   break;
      //   break;
      case 'voting':
        this.onVoting(data.message.data.voteFor);
        break;
      case 'clear_3d':
        this.killAll();
        break;
      case 'update_language':
        this.updateLanguage();
        break;
    }
  }

  relocateLeaderboard() {
    this.camera.updateMatrixWorld(true);

    const cameraPosition = new THREE.Vector3();
    const cameraDirection = new THREE.Vector3();

    this.camera.getWorldPosition(cameraPosition);
    this.camera.getWorldDirection(cameraDirection);

    // Project camera direction onto horizontal plane (XZ)
    const dirY = cameraDirection.y;
    cameraDirection.y = 0; // Math.min(1, Math.max(0, 0.5))
    cameraDirection.normalize();

    // Set fixed eye-level height (you can adjust this based on actual height)
    const eyeLevelY = Math.min(2, Math.max(-2, dirY));
    cameraPosition.y = eyeLevelY;

    const newPosition = cameraPosition
      .clone()
      .add(cameraDirection.multiplyScalar(0.1)); // 0.5 meters in front of the camera

    this.leaderboardGroup.position.copy(newPosition);

    // Make it face the camera (but keep it upright)
    // this.leaderboardGroup.lookAt(cameraPosition)
    this.leaderboardGroup.lookAt(
      new THREE.Vector3(cameraPosition.x, eyeLevelY, cameraPosition.z)
    );
  }

  updateLanguage() {
    if (this.title) {
      const map =
        Global.assets.textures[`${this.title1Base}${Global.lang}`].asset;
      map.encoding = THREE.sRGBEncoding;
      map.colorSpace = THREE.SRGBColorSpace;
      this.title.material.map = map;
    }
    if (this.title2Material) {
      const map2 = Global.assets.textures[`leaderboard3_${Global.lang}`].asset;
      map2.encoding = THREE.sRGBEncoding;
      map2.colorSpace = THREE.SRGBColorSpace;

      this.title2Material.map = map2;
    }

    if (this.chocolateLabel) {
      const chocolateMap =
        Global.assets.textures[`chocolate_label_${Global.lang}`].asset; // .clone()
      chocolateMap.encoding = THREE.sRGBEncoding;
      chocolateMap.colorSpace = THREE.SRGBColorSpace;
      this.chocolateLabel.material.map = chocolateMap;
      const hazelnutMap =
        Global.assets.textures[`hazelnut_label_${Global.lang}`].asset; // .clone()
      hazelnutMap.encoding = THREE.sRGBEncoding;
      hazelnutMap.colorSpace = THREE.SRGBColorSpace;
      this.hazelnutLabel.material.map = hazelnutMap;

      const chocolateScoreMap =
        Global.assets.textures[`chocolate_score_${Global.lang}`].asset; // .clone()
      chocolateScoreMap.encoding = THREE.sRGBEncoding;
      chocolateScoreMap.colorSpace = THREE.SRGBColorSpace;
      this.chocolateScore.material.map = chocolateScoreMap;
      const hazelnutScoreMap =
        Global.assets.textures[`hazelnut_score_${Global.lang}`].asset; // .clone()
      hazelnutScoreMap.encoding = THREE.sRGBEncoding;
      hazelnutScoreMap.colorSpace = THREE.SRGBColorSpace;
      this.hazelnutScore.material.map = hazelnutScoreMap;
    }

    if (this.platformchocolate) {
      const platformMap =
        Global.assets.textures[`leader_platform_${Global.lang}`].asset; // .clone()
      platformMap.encoding = THREE.sRGBEncoding;
      platformMap.colorSpace = THREE.SRGBColorSpace;

      this.platformchocolate.material.map = platformMap;
      this.platformhazelnut.material.map = platformMap;
    }
  }

  onVoting(voteFor) {
    if (!this.canDoVoting) return false;

    this.canDoVoting = false;
    document.querySelector('.leaderboard_ui').classList.remove('active');

    Global.serverObj.send(
      `${Global.BASE_URL}webservice.php`,
      (response) => {
        const data = JSON.parse(response);
        if (data.code == 200) {
        } else {
        }
      },
      null,
      {
        uniqID: Global.U_ID,
        saveType: 'saveVote',
        vote: voteFor,
      },
      'POST',
      null,
      false
    );

    gsap.killTweensOf(this[`${voteFor}Mesh`].rotation);
    gsap.to(this[`${voteFor}Mesh`].rotation, {
      y: Math.PI * 3.23 + Math.PI * 2,
      duration: 2,
      delay: 0,
      ease: 'elastic.out(1,0.5)',
      onComplete: () => {},
    });
    gsap.to(this[`${voteFor}Mesh`].position, {
      z: `+=${1.5}`,
      x: 0,
      duration: 2,
      delay: 0,
      ease: 'cubic.inOut',
      onComplete: () => {},
    });
    gsap.to(this[`${voteFor}Mesh`].scale, {
      x: 3,
      y: 3,
      z: 3,
      duration: 2,
      delay: 0,
      ease: 'cubic.inOut',
      onComplete: () => {
        Global.events.dispatchEvent({
          type: 'GAMESCENE_EVENTS',
          message: {
            event_type: 'clear_3d',
            data: {},
          },
        });
        Global.votedKey = voteFor;
        this.events.dispatchEvent({
          type: 'LOADER_EVENTS',
          message: {
            event_type: 'switch_page',
            data: {
              screenKey: 'Result',
            },
          },
        });
      },
    });
  }

  killAll() {
    if (this.leaderboardGroup) {
      document.querySelector('.leaderboard_ui').classList.remove('active');
      // Traverse and dispose all meshes inside the group
      this.leaderboardGroup.traverse((child) => {
        if (child.isMesh) {
          child.geometry?.dispose();
          child.material?.dispose();
        }
      });

      // Remove the group from the scene and clear the reference
      this.scene.remove(this.leaderboardGroup);
      this.leaderboardGroup = null;
    }

    // Optionally reset stack counts if needed
    this.hazelStackCount = 0;
    this.chocoStackCount = 0;
  }

  onReady() {
    this.environmentMap = Global.assets.cubemap['0'].asset;
    this.hazelnutFull = Global.assets.glbs.hazelnut_full.asset.scene.clone();
    this.hazelnut = Global.assets.glbs.hazelnut.asset.scene.clone();
    this.chocolateFull = Global.assets.glbs.chocolate_full.asset.scene.clone();
    this.chocolate = Global.assets.glbs.chocolate.asset.scene.clone();
    this.addLight(this.hazelnutFull);
    this.addLight(this.chocolateFull);
  }

  enableVoting() {
    Global.clickUpdater('voteNow');
    if (this.alreadyVoted) {
      Global.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'clear_3d',
          data: {},
        },
      });
      this.events.dispatchEvent({
        type: 'LOADER_EVENTS',
        message: {
          event_type: 'switch_page',
          data: {
            screenKey: 'Result',
          },
        },
      });
      return false;
    }
    document
      .querySelector('.leaderboard_ui #voteNow')
      .classList.remove('active');

    const labelObj = {
      value: 1,
    };
    gsap.to(labelObj, {
      value: 0,
      duration: 0.75,
      delay: 0.25,
      onUpdate: function (labelObj) {
        this[`hazelnutScore`].material.opacity = labelObj.value;
        this[`chocolateScore`].material.opacity = labelObj.value;

        this[`hazelnutscoreMat`].opacity = labelObj.value;
        this[`chocolatescoreMat`].opacity = labelObj.value;
      }.bind(this, labelObj),
      //   ease: 'elastic.out(1,0.5)',
    });

    for (let i = 0; i < this.hazelStackCount; i++) {
      gsap.to(this[`hazelnutStack${i + 1}`].position, {
        y: `-=${i * 0.21}`,
        duration: 1,
        onStart: () => {},

        onComplete: () => {
          // this[`hazelnutStack${i + 1}`].geometry.dispose();
          // this[`hazelnutStack${i + 1}`].material.dispose();
          this.leaderboardGroup.remove(this[`hazelnutStack${i + 1}`]);
        },
        delay: i * 0.05 + 0.0,
        ease: 'elastic.in(1,0.85)',
      });
    }
    gsap.to(this.title2.scale, {
      x: 1,
      y: 1,
      z: 1,
      duration: 1,
      delay: 2.5,
      ease: 'elastic.out(1,0.5)',
    });
    if (this.chocoStackCount > 0) {
      for (let i = 0; i < this.chocoStackCount; i++) {
        gsap.to(this[`chocolateStack${i + 1}`].position, {
          y: `-=${i * 0.21}`,
          duration: 1,
          onStart: () => {},
          onComplete: () => {
            // this[`chocolateStack${i + 1}`].geometry.dispose();
            // this[`chocolateStack${i + 1}`].material.dispose();
            this.leaderboardGroup.remove(this[`chocolateStack${i + 1}`]);
            // this[`chocolateStack${i + 1}`].visible = false;
            if (i == this.chocoStackCount - 1) {
              this.onStackHidden();
            }
          },
          delay: i * 0.05 + 0.0,
          ease: 'elastic.in(1,0.85)',
        });
      }
    } else {
      this.onStackHidden();
    }
  }

  onStackHidden() {
    this.platformItems.forEach((item) => {
      item.geometry.dispose();
      item.material.dispose();
      this.leaderboardGroup.remove(item);
    });
    const finalY =
      (this.chocolateMesh.position.y + this.hazelnutMesh.position.y) / 2;
    gsap.to(this.chocolateMesh.position, {
      y: finalY - 1.0,
      duration: 1,
      onStart: () => {},
      onComplete: () => {},
      ease: 'cubic.inOut',
    });
    gsap.to(this.hazelnutMesh.position, {
      y: finalY - 1.0,
      duration: 1,
      onStart: () => {},
      onComplete: () => {},
      ease: 'cubic.inOut',
    });
    gsap.to(this.chocolateLabel.position, {
      y: finalY - 0.6,
      duration: 1,
      onStart: () => {},
      onComplete: () => {},
      ease: 'cubic.inOut',
    });
    gsap.to(this.hazelnutLabel.position, {
      y: finalY - 0.6,
      duration: 1,
      onStart: () => {},
      onComplete: () => {},
      ease: 'cubic.inOut',
    });
    gsap.to(this.title.position, {
      y: finalY + 0.75 - 0.5,
      duration: 1,
      onStart: () => {},
      onComplete: () => {},
      ease: 'cubic.inOut',
    });

    setTimeout(() => {
      this.title.scale.set(0, 0, 0);
      gsap.to(this.title.scale, {
        x: 1.5,
        y: 1.5,
        z: 1.5,
        duration: 1,
        onStart: () => {
          this.title1Base = 'leaderboard1_';
          const map =
            Global.assets.textures[`leaderboard1_${Global.lang}`].asset;
          map.encoding = THREE.sRGBEncoding;
          map.colorSpace = THREE.SRGBColorSpace;
          this.title.material.map = map;
          this.canDoVoting = true;
        },
        delay: 0,
        onComplete: () => {},
        ease: 'elastic.out(1,0.5)',
      });
    }, 1000);
  }
  addLight(cookie) {
    cookie.traverse((child) => {
      if (!child.material) return;
      const { map } = child.material;
      child.material.envMap = this.environmentMap;
      map.encoding = THREE.sRGBEncoding;
      map.colorSpace = THREE.SRGBColorSpace;
      child.material.metalness = 0.1;
      child.material.roughness = 0.45;
      child.material.envMapIntensity = 2.5;
    });
  }

  showLeader(data) {
    if (data.screenKey != 'show_leader') return false;

    this.title1Base = 'flavour_leaderboard_';
    Global.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'clear_3d',
        data: {},
      },
    });
    this.alreadyVoted = false;
    Global.serverObj.send(
      `${Global.BASE_URL}webservice.php`,
      (response) => {
        try {
          const data = JSON.parse(response);
          if (data.code == 200) {
          } else if (data.code == 400) {
            this.alreadyVoted = true;
            Global.votedKey = data.vote;
          }
          document.querySelector('.leaderboard_ui').classList.add('active');
          document
            .querySelector('.leaderboard_ui #voteNow')
            .classList.add('active');
          this.hazelnutVotes = data.hazelnut;
          this.chocolateVotes = data.chocolate;

          this.hazelnutScoreVal = data.hazelnutSum;
          this.chocolateScoreVal = data.chocolateSum;

          this.activateLeaderboard();
        } catch (err) {}
      },
      null,
      {
        uniqID: Global.U_ID,
        saveType: 'voteCount',
      },
      'POST',
      null,
      false
    );
  }

  activateLeaderboard() {
    const offset = 1;
    this.leaderboardGroup = new THREE.Group();
    this.leaderboardGroup.userData.itemType = 'leader_group';
    this.scene.add(this.leaderboardGroup);
    this.canDoVoting = false;

    this.hazelStackCount = Math.min(this.hazelnutVotes, 8);
    this.chocoStackCount = Math.min(this.chocolateVotes, 8);

    if (this.hazelnutVotes < this.chocolateVotes) {
      this.hazelStackCount -= 2;
    } else {
      this.chocoStackCount -= 2;
    }
    if (this.hazelnutVotes <= 6) {
      this.hazelStackCount = Math.max(this.hazelnutVotes, this.hazelStackCount);
    }
    if (this.chocolateVotes <= 6) {
      this.chocoStackCount = Math.max(
        this.chocolateVotes,
        this.chocoStackCount
      );
    }

    if (this.hazelStackCount > 0) {
      for (let i = 0; i < this.hazelStackCount; i++) {
        this[`hazelnutStack${i + 1}`] = this.hazelnutFull.clone();
        this.leaderboardGroup.add(this[`hazelnutStack${i + 1}`]);
        this[`hazelnutStack${i + 1}`].position.set(
          -0.65,
          (-2.55 + 1) * offset + i * 0.22 * 0,
          -3 * 1.5 + 0.15 * 0
        );
        this[`hazelnutStack${i + 1}`].scale.set(0.45, 0.45, 0.45);
        this[`hazelnutStack${i + 1}`].visible = false;
        gsap.to(this[`hazelnutStack${i + 1}`].position, {
          y: `+=${i * 0.21}`,
          duration: 1,
          onStart: () => {
            this[`hazelnutStack${i + 1}`].visible = true;
          },

          onComplete: () => {
            if (i === this.hazelStackCount - 1) {
              this.showCookie('hazelnut', offset);
            }
          },
          delay: i * 0.05 + 0.5,
          ease: 'elastic.out(1,0.5)',
        });
      }
    } else {
      this.showCookie('hazelnut', offset);
    }

    if (this.chocoStackCount > 0) {
      for (let i = 0; i < this.chocoStackCount; i++) {
        this[`chocolateStack${i + 1}`] = this.chocolateFull.clone();
        this.leaderboardGroup.add(this[`chocolateStack${i + 1}`]);
        this[`chocolateStack${i + 1}`].position.set(
          0.65,
          (-2.55 + 1) * offset + i * 0.22 * 0,
          -3 * 1.5 + 0.15 * 0
        );
        this[`chocolateStack${i + 1}`].scale.set(0.45, 0.45, 0.45);
        this[`chocolateStack${i + 1}`].visible = false;

        gsap.to(this[`chocolateStack${i + 1}`].position, {
          y: `+=${i * 0.21}`,
          duration: 1,
          onStart: () => {
            this[`chocolateStack${i + 1}`].visible = true;
          },
          onComplete: () => {
            if (i === this.chocoStackCount - 1) {
              this.showCookie('chocolate', offset);
            }
          },
          delay: i * 0.05 + 0.5,
          ease: 'elastic.out(1,0.5)',
        });
      }
    } else {
      this.showCookie('chocolate', offset);
    }

    const titlePadd = Math.max(this.hazelStackCount, this.chocoStackCount) + 4;
    const map =
      Global.assets.textures[`flavour_leaderboard_${Global.lang}`].asset;
    map.encoding = THREE.sRGBEncoding;
    map.colorSpace = THREE.SRGBColorSpace;
    this.titleGeometry = new THREE.PlaneGeometry(0.4 * 3.13, 0.4, 1, 1);

    const map2 = Global.assets.textures[`leaderboard3_${Global.lang}`].asset;
    map2.encoding = THREE.sRGBEncoding;
    map2.colorSpace = THREE.SRGBColorSpace;
    this.title2Geometry = new THREE.PlaneGeometry(0.5 * 4.48, 0.5, 1, 1);

    this.titleMaterial = new THREE.MeshStandardMaterial({
      map,
      transparent: true,
      // opacity: 0,
      roughness: 1.0,
      metalness: 0.0,
      transparent: true,
      envMap: this.environmentMap,
      envMapIntensity: 4.5,
      // depthTest: false,
    });
    this.title2Material = new THREE.MeshStandardMaterial({
      map: map2,
      transparent: true,
      roughness: 1.0,
      metalness: 0.0,
      transparent: true,
      envMap: this.environmentMap,
      envMapIntensity: 4.5,
      // depthTest: false,
    });

    this.title = new THREE.Mesh(this.titleGeometry, this.titleMaterial);
    this.leaderboardGroup.add(this.title);
    this.title.position.set(
      0,
      (-1.75 + 1) * offset + titlePadd * 0.22,
      -2.5 * 1.5 + 0.15 * 0
    );
    this.title.scale.set(0, 0, 0);

    this.title2 = new THREE.Mesh(this.title2Geometry, this.title2Material);
    this.leaderboardGroup.add(this.title2);
    this.title2.position.set(
      0,
      (-5.4 + 1) * offset + titlePadd * 0.2,
      -2.5 * 1.8 + 0.15 * 0
    );
    this.title2.scale.set(0, 0, 0);

    gsap.to(this.title.scale, {
      x: 1.5,
      y: 1.5,
      z: 1.5,
      duration: 1,
      delay: 3,
      ease: 'elastic.out(1,0.5)',
    });

    this.addPlatform(
      'hazelnut',
      this.hazelnutFull,
      this.hazelnutVotes,
      this.hazelnutScoreVal,
      offset
    );
    this.addPlatform(
      'chocolate',
      this.chocolateFull,
      this.chocolateVotes,
      this.chocolateScoreVal,
      offset
    );

    this.relocateLeaderboard();
  }

  showCookie(cookieKey, offset) {
    this[`${cookieKey}Mesh`] = this[cookieKey].clone();
    this.addLight(this[`${cookieKey}Mesh`]);
    this.leaderboardGroup.add(this[`${cookieKey}Mesh`]);

    const map =
      Global.assets.textures[`${cookieKey}_label_${Global.lang}`].asset; // .clone()
    map.encoding = THREE.sRGBEncoding;
    map.colorSpace = THREE.SRGBColorSpace;

    const mapScore =
      Global.assets.textures[`${cookieKey}_score_${Global.lang}`].asset; // .clone()
    mapScore.encoding = THREE.sRGBEncoding;
    mapScore.colorSpace = THREE.SRGBColorSpace;

    if (!this.labelGeometry) {
      this.labelGeometry = new THREE.PlaneGeometry(0.4 * 1.86, 0.4, 1, 1);
    }
    if (!this.scoreGeometry) {
      this.scoreGeometry = new THREE.PlaneGeometry(0.4 * 1.84, 0.4, 1, 1);
    }

    this[`${cookieKey}Mesh`].userData.itemType = 'voting_cookie';
    this[`${cookieKey}Mesh`].userData.voteFor = cookieKey;
    this.cookielabel = new THREE.MeshStandardMaterial({
      map,
      transparent: true,
      opacity: 0,
      roughness: 1.0,
      metalness: 0.0,
      transparent: true,
      envMap: this.environmentMap,
      envMapIntensity: 4.5,
      // depthTest: false,
    });
    this.cookieScore = new THREE.MeshStandardMaterial({
      map: mapScore,
      transparent: true,
      opacity: 0,
      roughness: 1.0,
      metalness: 0.0,
      transparent: true,
      envMap: this.environmentMap,
      envMapIntensity: 4.5,
      depthTest: false,
    });

    this[`${cookieKey}Label`] = new THREE.Mesh(
      this.labelGeometry,
      this.cookielabel
    );
    this[`${cookieKey}Score`] = new THREE.Mesh(
      this.scoreGeometry,
      this.cookieScore
    );
    this.leaderboardGroup.add(this[`${cookieKey}Label`]);
    this.leaderboardGroup.add(this[`${cookieKey}Score`]);

    this[`${cookieKey}Label`].position.set(
      0.9 * (cookieKey === 'hazelnut' ? -1 : 1),
      (-2.25 + 1.15) * offset +
        ((cookieKey === 'hazelnut'
          ? Math.min(7, this.hazelStackCount)
          : Math.min(7, this.chocoStackCount)) +
          2) *
          0.23,
      -2.0 * 1.5 + 0.15 * 0
    );
    this[`${cookieKey}Score`].position.set(
      0.9 * (cookieKey === 'hazelnut' ? -1 : 1),
      (-2.25 + 1.15) * offset +
        ((cookieKey === 'hazelnut'
          ? Math.min(7, this.hazelStackCount)
          : Math.min(7, this.chocoStackCount)) +
          2) *
          0.23 +
        1,
      -2.0 * 1.5 + 0.15 * 0
    );

    this[`${cookieKey}Mesh`].position.set(
      0.5 * (cookieKey === 'hazelnut' ? -1 : 1),
      (-2.5 + 1.15) * offset +
        ((cookieKey === 'hazelnut'
          ? Math.min(7, this.hazelStackCount)
          : Math.min(7, this.chocoStackCount)) +
          2) *
          0.22,
      -2.5 * 1.5 + 0.15 * 0
    );
    this[`${cookieKey}Label`].position.y =
      this[`${cookieKey}Mesh`].position.y + 0.3;

    this[`${cookieKey}Score`].position.y =
      this[`${cookieKey}Mesh`].position.y - 0.01;

    this[`${cookieKey}Mesh`].scale.set(0, 0, 0);

    const labelObj = {
      value: 0,
    };
    gsap.to(labelObj, {
      value: 1,
      duration: 0.75,
      delay: 1,
      onUpdate: function (cookielabel, cookieScore, labelObj, cookieKey) {
        cookielabel.opacity = labelObj.value;
        cookieScore.opacity = labelObj.value;
        this[`${cookieKey}scoreMat`].opacity = labelObj.value;
      }.bind(this, this.cookielabel, this.cookieScore, labelObj, cookieKey),
      //   ease: 'elastic.out(1,0.5)',
    });
    gsap.to(this[`${cookieKey}Mesh`].scale, {
      x: 0.45,
      y: 0.45,
      z: 0.45,
      duration: 2,
      delay: 0,
      ease: 'elastic.out(1,0.5)',
    });
    gsap.to(this[`${cookieKey}Mesh`].rotation, {
      y: Math.PI * 2.2,
      duration: 2,
      delay: 0,
      ease: 'elastic.out(1,0.5)',
      onComplete: () => {
        gsap.to(this[`${cookieKey}Mesh`].rotation, {
          y: `+=${
            Math.PI *
            0.035 *
            (Math.random() < 0.5 ? 1 : -1) *
            Math.max(0.5, Math.random())
          }`,
          duration: 2,
          delay: 0,
          yoyo: true,
          delay: Math.random(),
          ease: 'cubic.inOut',
          repeat: -1,
        });
      },
    });
  }

  addPlatform(type, cookie, votes, score, offset) {
    // console.log(type, votes, score, offset);
    if (!this.platformGeometry) {
      this.platformGeometry = new THREE.PlaneGeometry(1 * 1.98, 1, 1, 1);
    }
    if (!this.platformMaterial) {
      const map =
        Global.assets.textures[`leader_platform_${Global.lang}`].asset; // .clone()
      map.encoding = THREE.sRGBEncoding;
      map.colorSpace = THREE.SRGBColorSpace;

      this.platformMaterial = new THREE.MeshStandardMaterial({
        map,
        roughness: 1.0,
        metalness: 0.0,
        transparent: true,
        envMap: this.environmentMap,
        side: THREE.DoubleSide,
        envMapIntensity: 3.5,
      });
    }

    this[`platform${type}`] = new THREE.Mesh(
      this.platformGeometry,
      this.platformMaterial
    );

    this.leaderboardGroup.add(this[`platform${type}`]);
    this[`platform${type}`].position.set(
      0.65 * (type === 'hazelnut' ? -1 : 1),
      (-3.0 + 1) * offset,
      -2.9 * 1.5 + 0.15 * 0
    );
    // platform.rotation.set(-Math.PI * 0.5, 0, 0);
    this[`platform${type}`].scale.set(0.6, 0.6, 0.6);

    this.fontLoader = new FontLoader();
    this.fontLoader.load(
      'https://d2xrkn56aw2rdo.cloudfront.net/OreoNewFlavour/Pluto_Cond_Black_Regular.typeface.json',
      (font) => {
        const text = String(votes);
        const scoreText = String(score);
        const geometry = new TextGeometry(text, {
          font,
          size: 0.25,
          height: 0.01,
        });
        const scoreGeo = new TextGeometry(scoreText, {
          font,
          size: 0.1,
          height: 0.01,
        });

        // Compute bounding box to center the geometry
        geometry.computeBoundingBox();
        scoreGeo.computeBoundingBox();

        const { boundingBox } = geometry;
        const textWidth = boundingBox.max.x - boundingBox.min.x;

        // Shift geometry to center it
        geometry.translate(-textWidth / 2, 0, 0);
        const material = new THREE.MeshBasicMaterial({ color: 0xffffff });
        const mesh = new THREE.Mesh(geometry, material);
        mesh.scale.z = 0.0001;
        // This now places it centered on the platform
        mesh.position.set(0, -0.0, 0.1);
        this[`platform${type}`].add(mesh);

        this.platformItems.push(this[`platform${type}`]);
        this.platformItems.push(mesh);

        const scoreBoundingBox = scoreGeo.boundingBox;
        const scoretextWidth = scoreBoundingBox.max.x - scoreBoundingBox.min.x;

        // Shift geometry to center it
        scoreGeo.translate(-scoretextWidth / 2, 0, 0);
        this[`${type}scoreMat`] = new THREE.MeshBasicMaterial({
          color: 0x3066c2,
          opacity: 0,
          transparent: true,
        });
        const scoreMesh = new THREE.Mesh(scoreGeo, this[`${type}scoreMat`]);
        scoreMesh.scale.z = 0.0001;
        // This now places it centered on the platform
        scoreMesh.position.set(0, -0.0, 0.1);
        this.leaderboardGroup.add(scoreMesh);

        // this.platformItems.push(this[`platform${type}`]);
        this.platformItems.push(scoreMesh);

        scoreMesh.position.set(
          0.9 * (type === 'hazelnut' ? -1 : 1),
          (-2.5 + 1.15) * offset +
            ((type === 'hazelnut'
              ? Math.min(7, this.hazelStackCount)
              : Math.min(7, this.chocoStackCount)) +
              2) *
              0.22 -
            0.06,
          -2.0 * 1.5 + 0.01
        );
        // scoreMesh.position.y = this[`${type}Mesh`].position.y + 0.3 - 0.29;
      }
    );
    // this.fontLoader.load('https://d2xrkn56aw2rdo.cloudfront.net/OreoNewFlavour/plutocondregular.typeface.json', (font) => {
    // const text = String('OREO CREDITS')
    // const geometry = new TextGeometry(text, {
    //     font,
    //     size: 0.08,
    //     height: 0.01,
    // })
    //
    // // Compute bounding box to center the geometry
    // geometry.computeBoundingBox()
    //
    // const {boundingBox} = geometry
    // const textWidth = boundingBox.max.x - boundingBox.min.x
    //
    // // Shift geometry to center it
    // geometry.translate(-textWidth / 2, 0, 0)
    // const material = new THREE.MeshBasicMaterial({color: 0xffffff})
    // this[`platform${type}Txt`] = new THREE.Mesh(geometry, material)
    //
    // // This now places it centered on the platform
    // this[`platform${type}Txt`].position.set(0, -0.2, 0.1)
    // this[`platform${type}Txt`].scale.z = 0.0001
    // platform.add(this[`platform${type}Txt`])
    // })
  }
}
